package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2026_05_30_Day_1
import com.veldekar.components.logs.Log_2026_05_30_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2026-05-30")
@Composable
public fun Log_2026_05_30(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "All Fun and Games Until Our Tools Become Self-Aware",
        ogTitle = "All Fun and Games Until Our Tools Become Self-Aware",
        date = LocalDate(2_026, 5, 30),
        aiHint = "Title references the similarity between the events in the campaign and the growing power of AI agents in the real world.",
        ogDescription = "Annette is incapacitated by laughter while the Dino-twins Caper and Bigglesworth stomp the Drow to claim the shard of Concar. Is Bigglesworth’s new sentient blade, Razorwrath, a gift from the gods or the first seeds of the heroes’ destruction?",
        ogImage = "images/AnnetteLaughingCaperDinoRazorwrath.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "shimmer-31", dateString = "Shimmer 31", cardImageSrc = "images/razorwrath.webp", width = 1_200, height = 285)
        Log_2026_05_30_Day_1()
        SessionDayHeader(dayId = "shimmer-32", dateString = "Shimmer 32")
        Log_2026_05_30_Day_2()
        SessionMediaItem(
            image = "images/AnnetteLaughingCaperDino_details.webp",
            linkImage = "images/AnnetteLaughingCaperDino_details.webp",
            width = 2_016,
            height = 1_293,
        )
    }
}
